export const activeOptions: {name: string, value: boolean}[] = [
  {name: 'active', value: true},
  {name: 'not-active', value: false},
];